import { createRouter, createWebHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import Login from "../views/LoginView.vue";
import NotFoundView from "../views/NotFoundView.vue";
import SiteView from "../views/SiteView.vue";
import SiteDetailView from "@/views/SiteDetailView.vue";
import AddSiteView from "@/views/AddSiteView.vue";
import TunnelView from "@/views/TunnelView.vue";
import TunnelDetailView from "@/views/TunnelDetailView.vue";
import AddTunnelView from "@/views/AddTunnelView.vue";
import BlackboxView from "@/views/BlackboxView.vue";
import BlackboxDetails from "@/views/BlackboxDetails.vue";
import AddBlackbox from "@/views/AddBlackbox.vue";
import HostAvailabilityView from "@/views/HostAvailabilityView.vue";
import HostAvailabilityDetails from "@/views/HostAvailabilityDetails.vue";
import AddHostAvailability from "@/views/AddHostAvailability.vue";
import AlertContactsView from "@/views/AlertContactsView.vue";
import AlertContactForm from "@/views/AlertContactForm.vue";
import AlertContactDetails from "@/views/AlertContactDetails.vue";
import NetworkDeviceView from "@/views/NetworkDeviceView.vue";
import NetworkDeviceDetails from "@/views/NetworkDeviceDetails.vue";
import AddNetworkDevice from "@/views/AddNetworkDevice.vue";
import ProbeView from "@/views/ProbeView.vue";
import ProbeDetails from "@/views/ProbeDetails.vue";
import AddProbe from "@/views/AddProbe.vue";
import DivisionView from "@/views/DivisionView.vue";
import DivisionDetails from "@/views/DivisionDetails.vue";
import AddDivision from "@/views/AddDivision.vue";
import LoadsheddingView from "@/views/LoadsheddingView.vue";
import LoadsheddingDetails from "@/views/LoadsheddingDetails.vue";
import AddLoadshedding from "@/views/AddLoadshedding.vue";
import UserView from "@/views/UserView.vue";
import UserDetails from "@/views/UserDetails.vue";
import EditUser from "@/views/EditUser.vue";
import OrganizationView from "@/views/OrganizationView.vue";
import OrganizationDetails from "@/views/OrganizationDetails.vue";
import ModuleView from "@/views/ModuleView.vue";
import ModuleDetails from "@/views/ModuleDetails.vue";
import LogView from "@/views/LogView.vue";
import LogDetails from "@/views/LogDetails.vue";
import AuditLogView from "@/views/AuditLogView.vue";
import AuditLogDetails from "@/views/AuditLogDetails.vue";
import AccessLogView from "@/views/AccessLogView.vue";
import AccessLogDetails from "@/views/AccessLogDetails.vue";
import ConfigView from "@/views/ConfigView.vue";
import ChangesDetails from "@/views/ChangesDetails.vue";
import UserAccountDetails from "@/views/UserAccountDetails.vue";
import MyAccount from "@/views/MyAccount.vue";
import PasswordChange from "@/components/PasswordChange.vue";
import ConfigurationDetails from "@/views/ConfigurationDetails.vue";
import DashboardView from "@/views/DashboardView.vue";
import AddUser from "@/views/AddUser.vue";
import PasswordResetRequestView from "@/views/PasswordResetRequestView.vue";
import PasswordResetConfirmView from "@/views/PasswordResetConfirmView.vue";
import WorkSpaceOrganizationDetails from "@/views/WorkSpaceOrganizationDetails.vue";
import WorkSpaceOrganizationView from "@/views/WorkSpaceOrganizationView.vue";
import RateLimitDetails from "@/views/RateLimitDetails.vue";
import RateLimitsView from "@/views/RateLimitsView.vue";
import AgentGroupDetails from "@/views/AgentGroupDetails.vue";
import AgentGroupView from "@/views/AgentGroupView.vue";
import AgentDetails from "@/views/AgentDetails.vue";
import AgentView from "@/views/AgentView.vue";
import BinaryDetails from "@/views/BinaryDetails.vue";
import BinaryView from "@/views/BinaryView.vue";
import ConfigWorkSpaceDetails from "@/views/ConfigWorkSpaceDetails.vue";
import ConfigWorkSpaceView from "@/views/ConfigWorkSpaceView.vue";
import UpdateQueueDetails from "@/views/UpdateQueueDetails.vue";
import UpdateQueueView from "@/views/UpdateQueueView.vue";
import AgentPendingDetails from "@/views/AgentPendingDetails.vue";
import AlloyView from "@/views/AlloyView.vue";
import AlloyDetails from "@/views/AlloyDetails.vue";
import AddAlloy from "@/views/AddAlloy.vue";
import AddAlloySNMP from "@/views/AddAlloySNMP.vue";
import AddAlloyBlackbox from "@/views/AddAlloyBlackbox.vue";
import AddAlloyFortigate from "@/views/AddAlloyFortigate.vue";
import AddAlloyDarkstat from "@/views/AddAlloyDarkstat.vue";
import SNMPProfileList from "@/views/SNMPProfileList.vue";
import SNMPProfileDetails from "@/views/SNMPProfileDetails.vue";
import AddSNMPProfile from "@/views/AddSNMPProfile.vue";
import AddSNMPMetric from "@/views/AddSNMPMetric.vue";
import AddSNMPWalk from "@/views/AddSNMPWalk.vue";
import FortigateProfileList from "@/views/FortigateProfileList.vue";
import FortigateProfileDetails from "@/views/FortigateProfileDetails.vue";
import AddFortigateProfile from "@/views/AddFortigateProfile.vue";
import FortigateView from "@/views/FortigateView.vue";
import AddFortigate from "@/views/AddFortigate.vue";
import FortigateDetails from "@/views/FortigateDetails.vue";
import SSHCollectorView from "@/views/SSHCollectorView.vue";
import SSHCollectorDetails from "@/views/SSHCollectorDetails.vue";
import AddSSHCollector from "@/views/AddSSHCollector.vue";
import AddSSHCollectorTarget from "@/views/AddSSHCollectorTarget.vue";
import AddSSHCollectorMedicrossSite from "@/views/AddSSHCollectorMedicrossSite.vue";
import WiFiProfileListView from "@/views/WiFiProfileListView.vue";
import WiFiProfileDetails from "@/views/WiFiProfileDetails.vue";
import AddWiFiProfile from "@/views/AddWiFiProfile.vue";
import EditWiFiProfile from "@/views/EditWiFiProfile.vue";
import CaptureView from "@/views/CaptureView.vue";
import CaptureDetails from "@/views/CaptureDetails.vue";
import AddCapture from "@/views/AddCapture.vue";

import DeviceView from "@/views/MivuLite/DeviceView.vue";
import DeviceDetails from "@/views/MivuLite/DeviceDetails.vue";
import AdminView from "@/views/MivuLite/AdminView.vue";
import DashboardMLView from "@/views/MivuLite/DashboardMLView.vue";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    { 
      path: "/login", 
      name: "login", 
      component: Login 
    },
    {
      path: "/password_reset",
      name: "PasswordResetRequest",
      component: PasswordResetRequestView,
      meta: { requiresAuth: false }
    },
    {
      path: "/password_reset/:uid/:token",
      name: "PasswordResetConfirm",
      component: PasswordResetConfirmView,
      meta: { requiresAuth: false }
    },
    {
      path: "/",
      name: "home",
      component: DashboardView,
      meta: { requiresAuth: true },
    },
    {
      // The APM single pane of glass: Applications / Configure / Network are
      // tabs on one page. The old per-page routes below redirect into their tab.
      path: "/apm",
      name: "Application Performance Monitoring",
      component: () => import("@/views/ApmMonitoring.vue"),
      meta: { requiresAuth: true },
    },
    {
      path: "/apm/components",
      redirect: { path: "/apm", query: { tab: "applications" } },
    },
    {
      path: "/apm/dashboard",
      redirect: { path: "/apm", query: { tab: "applications" } },
    },
    {
      path: "/apm/configure",
      redirect: { path: "/apm", query: { tab: "configure" } },
    },
    {
      path: "/apm/network",
      redirect: { path: "/apm", query: { tab: "network" } },
    },
    {
      path: "/sites",
      name: "sites",
      component: SiteView,
      meta: { requiresAuth: true },
    },
    {
      path: "/sites/:id",
      name: "SiteDetail",
      component: SiteDetailView,
    },
    {
      path: "/sites/add",
      name: "AddSite",
      component: AddSiteView,
    },
    {
      path: "/tunnels",
      name: "Tunnels",
      component: TunnelView,
    },
    {
      path: "/tunnels/add",
      name: "AddTunnel",
      component: AddTunnelView,
    },
    {
      path: "/tunnels/:id",
      name: "TunnelDetail",
      component: TunnelDetailView,
      props: true,
    },
    {
      path: "/blackbox",
      name: "Blackboxes",
      component: BlackboxView,
    },
    {
      path: "/blackboxes/:id",
      name: "BlackboxDetails",
      component: BlackboxDetails,
    },
    {
      path: "/blackboxes/add",
      name: "AddBlackbox",
      component: AddBlackbox,
    },
    {
      path: "/host-availability",
      name: "HostAvailabilities",
      component: HostAvailabilityView,
    },
    {
      path: "/host-availability/add",
      name: "AddHostAvailability",
      component: AddHostAvailability,
    },
    {
      path: "/host-availability/:id",
      name: "HostAvailabilityDetails",
      component: HostAvailabilityDetails,
    },
    {
      path: "/alert-contacts",
      name: "AlertContacts",
      component: AlertContactsView,
    },
    {
      path: "/alert-contacts/add",
      name: "AddAlertContact",
      component: AlertContactForm,
    },
    {
      path: "/alert-contacts/:id/edit",
      name: "EditAlertContact",
      component: AlertContactForm,
      props: true,
    },
    {
      path: "/alert-contacts/:id",
      name: "AlertContactDetails",
      component: AlertContactDetails,
    },
    {
      path: "/network-devices",
      name: "NetworkDevices",
      component: NetworkDeviceView,
    },
    {
      path: "/network-devices/add",
      name: "AddNetworkDevice",
      component: AddNetworkDevice,
    },
    {
      path: "/network-devices/:id/edit",
      name: "EditNetworkDevice",
      component: AddNetworkDevice,
    },
    {
      path: "/network-devices/:id",
      name: "NetworkDeviceDetails",
      component: NetworkDeviceDetails,
    },
    {
      path: "/probe",
      name: "Probes",
      component: ProbeView,
    },
    {
      path: "/probes/:id",
      name: "ProbeDetails",
      component: ProbeDetails,
    },
    {
      path: "/probes/add",
      name: "AddProbe",
      component: AddProbe,
    },
    {
      path: "/division",
      name: "Divisions",
      component: DivisionView,
    },
    {
      path: "/divisions/:id",
      name: "DivisionDetails",
      component: DivisionDetails,
    },
    {
      path: "/divisions/add",
      name: "AddDivision",
      component: AddDivision,
    },
    {
      path: "/loadshedding",
      name: "Loadsheddings",
      component: LoadsheddingView,
    },
    {
      path: "/loadsheddings/:id",
      name: "LoadsheddingDetails",
      component: LoadsheddingDetails,
    },
    {
      path: "/loadsheddings/add",
      name: "AddLoadshedding",
      component: AddLoadshedding,
    },
    {
      path: "/users",
      name: "Users",
      component: UserView,
    },
    {
      path: "/users/add",
      name: "AddUser",
      component: AddUser,
      meta: { requiresAuth: true },
    },
    {
      path: "/users/:id",
      name: "UserDetails",
      component: UserDetails,
    },
    {
      path: "/users/:id/edit",
      name: "EditUser",
      component: EditUser,
    },
    {
      path: "/organizations",
      name: "Organizations",
      component: OrganizationView,
    },
    {
      path: "/organizations/:id",
      name: "OrganizationDetails",
      component: OrganizationDetails,
    },
    {
      path: "/modules",
      name: "Modules",
      component: ModuleView,
    },
    {
      path: "/modules/:id",
      name: "ModuleDetails",
      component: ModuleDetails,
    },
    {
      path: "/logs",
      name: "Logs",
      component: LogView,
    },
    {
      path: "/logs/:id",
      name: "LogDetails",
      component: LogDetails,
    },
    {
      path: "/audit-logs",
      name: "AuditLogs",
      component: AuditLogView,
    },
    {
      path: "/audit-logs/:id",
      name: "AuditLogDetails",
      component: AuditLogDetails,
    },
    {
      path: "/access-logs",
      name: "AccessLogs",
      component: AccessLogView,
    },
    {
      path: "/access-logs/:id",
      name: "AccessLogDetails",
      component: AccessLogDetails,
    },
    {
      path: "/access-attempts/:id",
      name: "AccessAttemptDetails",
      component: AccessLogDetails,
    },
    {
      path: "/config",
      name: "ConfigView",
      component: ConfigView,
    },
    {
      path: "/configuration/details/:type/:id",
      name: "ConfigurationDetails",
      component: ConfigurationDetails,
      props: true,
    },
    {
      path: "/changes/:type/:id",
      name: "changes-details",
      component: ChangesDetails,
    },
    {
      path: "/accounts/:id",
      name: "UserAccountDetails",
      component: UserAccountDetails,
    },
    {
      path: "/account",
      name: "MyAccount",
      component: MyAccount,
      meta: { requiresAuth: true },
    },
    {
      path: "/account/password",
      name: "PasswordChange",
      component: PasswordChange,
      meta: { requiresAuth: true },
    },
    {
      path: "/dashboard",
      name: "Dashboard",
      component: DashboardView,
      meta: { requiresAuth: true },
    },
    {
      path: "/wsorganizations",
      name: "WorkSpaceOrganizations",
      component: WorkSpaceOrganizationView,
    },
    {
      path: "/wsorganizations/:id",
      name: "WorkSpaceOrganizationDetails",
      component: WorkSpaceOrganizationDetails,
    },
    {
      path: "/ratelimits",
      name: "RateLimitsView",
      component: RateLimitsView,
    },
    {
      path: "/ratelimit/:id",
      name: "RateLimitDetails",
      component: RateLimitDetails,
    },
    {
      path: "/agentgroup",
      name: "AgentGroupView",
      component: AgentGroupView,
    },
    {
      path: "/agentgroup/:id",
      name: "AgentGroupDetails",
      component: AgentGroupDetails,
    },
    {
      path: "/agents",
      name: "AgentView",
      component: AgentView,
    },
    {
      path: "/agents/:id",
      name: "AgentDetails",
      component: AgentDetails,
    },
    {
      path: "/agent-pending/:id",
      name: "AgentPendingDetails",
      component: AgentPendingDetails,
    },
    {
      path: "/binary",
      name: "BinaryView",
      component: BinaryView,
    },
    {
      path: "/binary/:id",
      name: "BinaryDetails",
      component: BinaryDetails,
    },
    {
      path: "/configworkspace",
      name: "ConfigWorkSpaceView",
      component: ConfigWorkSpaceView,
    },
    {
      path: "/configworkspace/:id",
      name: "ConfigWorkSpaceDetails",
      component: ConfigWorkSpaceDetails,
    },
    {
      path: "/updatequeue",
      name: "UpdateQueueView",
      component: UpdateQueueView,
    },
    {
      path: "/updatequeue/:id",
      name: "UpdateQueueDetails",
      component: UpdateQueueDetails,
    },
    // Alloy Configuration Routes
    {
      path: "/alloy",
      name: "AlloyConfigs",
      component: AlloyView,
      meta: { requiresAuth: true },
    },
    {
      path: "/alloy/add",
      name: "AddAlloy",
      component: AddAlloy,
      meta: { requiresAuth: true },
    },
    {
      path: "/alloy/:id",
      name: "AlloyDetails",
      component: AlloyDetails,
      meta: { requiresAuth: true },
    },
    {
      path: "/alloy/:configId/snmp/add",
      name: "AddAlloySNMP",
      component: AddAlloySNMP,
      meta: { requiresAuth: true },
    },
    {
      path: "/alloy/:configId/snmp/:jobId/edit",
      name: "EditAlloySNMP",
      component: AddAlloySNMP,
      meta: { requiresAuth: true },
    },
    {
      path: "/alloy/:configId/blackbox/add",
      name: "AddAlloyBlackbox",
      component: AddAlloyBlackbox,
      meta: { requiresAuth: true },
    },
    {
      path: "/alloy/:configId/blackbox/:jobId/edit",
      name: "EditAlloyBlackbox",
      component: AddAlloyBlackbox,
      meta: { requiresAuth: true },
    },
    {
      path: "/alloy/:configId/fortigate/add",
      name: "AddAlloyFortigate",
      component: AddAlloyFortigate,
      meta: { requiresAuth: true },
    },
    {
      path: "/alloy/:configId/fortigate/:jobId/edit",
      name: "EditAlloyFortigate",
      component: AddAlloyFortigate,
      meta: { requiresAuth: true },
    },
    {
      path: "/alloy/:configId/darkstat/add",
      name: "AddAlloyDarkstat",
      component: AddAlloyDarkstat,
      meta: { requiresAuth: true },
    },
    {
      path: "/alloy/:configId/darkstat/:jobId/edit",
      name: "EditAlloyDarkstat",
      component: AddAlloyDarkstat,
      meta: { requiresAuth: true },
    },
    // SNMP Profile Routes
    {
      path: "/snmp-profiles",
      name: "SNMPProfiles",
      component: SNMPProfileList,
      meta: { requiresAuth: true },
    },
    {
      path: "/snmp-profiles/add",
      name: "AddSNMPProfile",
      component: AddSNMPProfile,
      meta: { requiresAuth: true },
    },
    {
      path: "/snmp-profiles/:id",
      name: "SNMPProfileDetails",
      component: SNMPProfileDetails,
      meta: { requiresAuth: true },
    },
    {
      path: "/snmp-profiles/:id/edit",
      name: "EditSNMPProfile",
      component: AddSNMPProfile,
      meta: { requiresAuth: true },
    },
    {
      path: "/snmp-profiles/:profileId/metrics/add",
      name: "AddSNMPMetric",
      component: AddSNMPMetric,
      meta: { requiresAuth: true },
    },
    {
      path: "/snmp-profiles/:profileId/metrics/:metricId/edit",
      name: "EditSNMPMetric",
      component: AddSNMPMetric,
      meta: { requiresAuth: true },
    },
    {
      path: "/snmp-profiles/:profileId/walks/add",
      name: "AddSNMPWalk",
      component: AddSNMPWalk,
      meta: { requiresAuth: true },
    },
    {
      path: "/snmp-profiles/:profileId/walks/:walkId/edit",
      name: "EditSNMPWalk",
      component: AddSNMPWalk,
      meta: { requiresAuth: true },
    },
    // Fortigate Profile Routes
    {
      path: "/fortigate-profiles",
      name: "FortigateProfiles",
      component: FortigateProfileList,
      meta: { requiresAuth: true },
    },
    {
      path: "/fortigate-profiles/add",
      name: "AddFortigateProfile",
      component: AddFortigateProfile,
      meta: { requiresAuth: true },
    },
    {
      path: "/fortigate-profiles/:id",
      name: "FortigateProfileDetails",
      component: FortigateProfileDetails,
      meta: { requiresAuth: true },
    },
    {
      path: "/fortigate-profiles/:id/edit",
      name: "EditFortigateProfile",
      component: AddFortigateProfile,
      meta: { requiresAuth: true },
    },
    // Standalone Fortigate Device Routes (restored from the single-instance
    // build; coexists with API Profiles (/fortigate-profiles) + Alloy API jobs).
    {
      path: "/fortigate",
      name: "Fortigates",
      component: FortigateView,
      meta: { requiresAuth: true },
    },
    {
      path: "/fortigate/add",
      name: "AddFortigate",
      component: AddFortigate,
      meta: { requiresAuth: true },
    },
    {
      path: "/fortigate/:id",
      name: "FortigateDetails",
      component: FortigateDetails,
      meta: { requiresAuth: true },
    },
    // SSH Collector Configuration Routes
    {
      path: "/ssh-collector",
      name: "SSHCollectorConfigs",
      component: SSHCollectorView,
      meta: { requiresAuth: true },
    },
    {
      path: "/ssh-collector/add",
      name: "AddSSHCollector",
      component: AddSSHCollector,
      meta: { requiresAuth: true },
    },
    {
      path: "/ssh-collector/:id",
      name: "SSHCollectorDetails",
      component: SSHCollectorDetails,
      meta: { requiresAuth: true },
    },
    {
      path: "/ssh-collector/:configId/target/add",
      name: "AddSSHCollectorTarget",
      component: AddSSHCollectorTarget,
      meta: { requiresAuth: true },
    },
    {
      path: "/ssh-collector/:configId/target/:jobId/edit",
      name: "EditSSHCollectorTarget",
      component: AddSSHCollectorTarget,
      meta: { requiresAuth: true },
    },
    {
      path: "/ssh-collector/:configId/medicross/add",
      name: "AddSSHCollectorMedicrossSite",
      component: AddSSHCollectorMedicrossSite,
      meta: { requiresAuth: true },
    },
    {
      path: "/ssh-collector/:configId/medicross/:jobId/edit",
      name: "EditSSHCollectorMedicrossSite",
      component: AddSSHCollectorMedicrossSite,
      meta: { requiresAuth: true },
    },
    // WiFi Profile Routes
    { path: "/wifi-profiles", name: "WiFiProfiles", component: WiFiProfileListView, meta: { requiresAuth: true } },
    { path: "/wifi-profiles/add", name: "AddWiFiProfile", component: AddWiFiProfile, meta: { requiresAuth: true } },
    { path: "/wifi-profiles/:id", name: "WiFiProfileDetails", component: WiFiProfileDetails, meta: { requiresAuth: true } },
    { path: "/wifi-profiles/:id/edit", name: "EditWiFiProfile", component: EditWiFiProfile, meta: { requiresAuth: true } },
    // Capture Routes
    { path: "/capture", name: "CaptureView", component: CaptureView, meta: { requiresAuth: true } },
    { path: "/capture/add", name: "AddCapture", component: AddCapture, meta: { requiresAuth: true } },
    { path: "/capture/:id", name: "CaptureDetails", component: CaptureDetails, meta: { requiresAuth: true } },
    {
      path: "/device",
      name: "DeviceView",
      component: DeviceView,
    },
    {
      path: "/device/:id",
      name: "DeviceDetails",
      component: DeviceDetails,
    },
    {
      path: "/admin",
      name: "AdminView",
      component: AdminView,
    },
    {
      path: "/dashboards",
      name: "DashboardMLView",
      component: DashboardMLView,
    },
    {
      path: "/:pathMatch(.*)*",
      name: "not-found",
      component: NotFoundView,
      meta: { requiresAuth: true },
    }, // Catch-all route
  ],
});

// Add navigation guards to check for authentication
router.beforeEach((to, from, next) => {
  const isAuthenticated = !!localStorage.getItem("token"); // Check if token exists

  // Allow routes that explicitly don't require auth
  if (to.meta.requiresAuth === false) {
    next();
    return;
  }

  // If route requires auth and user is not authenticated, redirect to login
  if (!isAuthenticated) {
    if (to.name !== 'login') {
      localStorage.setItem('redirectAfterLogin', to.fullPath);
      next({ name: "login" });
    } else {
      next();
    }
    return;
  }

  // If user is authenticated and tries to access login/reset pages, redirect to home
  if (isAuthenticated && (to.name === 'login' || to.meta.requiresAuth === false)) {
    next({ name: "home" });
    return;
  }

  // Otherwise proceed normally
  next();
});

export default router;
